const random_number_VIEWS = new Random_Number( { max_attempts: 50, max: 1000, min: 250 } );
const v_counter = ecommerce_counter(  '.e-commerce__products-views-people .current-views' , 18000, random_number_VIEWS );

v_counter(v_counter, true);